// Inspired by React implementation itself: https://codepen.io/gaearon/pen/wqvxGa?editors=0010
import React from 'react'
import { ErrorPage } from '@mafc/common'

interface IState {
  error: {} | any
  errorInfo: {} | any
}

interface IProps {
  children: React.Component | any
}

class ErrorBoundary extends React.Component<IProps, IState> {
  state: IState = {
    error: null,
    errorInfo: null
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo
    })
    // You can also log error messages to an error reporting service here
    // tslint:disable-next-line: no-console
    console.error('Error: ', errorInfo)
  }

  render() {
    const { errorInfo } = this.state
    const { children } = this.props

    if (errorInfo) {
      return <ErrorPage type='500' />
    }

    return children
  }
}

export default ErrorBoundary
